import { NAV_SECTIONS } from '@/config/navigation';
import type { Permissions } from '@/context/Permissions';

export const CHORD_PREFIX_KEY = 'g';
export const CHORD_TIMEOUT_MS = 1500;

export type GoToRoute = {
	to: string;
	/** Same optional gate as `NavItem` / `NavCommand`. Undefined = everyone. */
	permission?: (p: Permissions) => boolean;
};

// Derived from the sidebar: "G X" there is the chord here, with the same gate.
export const GO_TO_ROUTES: Record<string, GoToRoute> = Object.fromEntries(
	NAV_SECTIONS.flatMap((section) => section.items).map((item) => [
		item.shortcut.split(' ')[1].toLowerCase(),
		{ to: item.to, permission: item.permission },
	]),
);
